import { useSubscription } from 'services/hooks';
import { FormContainer, Header, HelperText } from './components';
import { StyledContainer, StyledOuterContainer } from './styled';

const WhitelistComponent = () => {
  const { isFreeAccount } = useSubscription();

  return (
    <StyledOuterContainer isFreeAccount={isFreeAccount}>
      <StyledContainer>
        <Header />
        <FormContainer />
      </StyledContainer>
      <HelperText />
    </StyledOuterContainer>
  );
};

export default WhitelistComponent;
